import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const InteractiveToursWrapper = styled(PhotographyWrapper)`
  .tour-hero-visual { margin: 0; }
  .tour-hero-visual img { display: block; width: 100%; height: 530px; object-fit: contain; }
  .tour-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
  .tour-intro .photo-title, .tour-intro .photo-copy { margin-bottom: 0; }
  .tour-format-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; margin-top: 36px; }
  .tour-format-grid article { border-top: 1px solid #cbd5e9; padding-top: 24px; }
  .tour-format-grid p:not(.photo-eyebrow), .tour-benefit-grid p { font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .tour-demo-band { background: #f6f8fc; }
  #tour-example { scroll-margin-top: 40px; }
  .tour-viewer { position: relative; aspect-ratio: 16 / 9; min-height: 400px; border-radius: 16px; overflow: hidden; background: #1b264f; isolation: isolate; }
  .tour-viewer iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; opacity: 0; }
  .tour-viewer.is-loaded iframe { opacity: 1; }
  .tour-cover { position: absolute; inset: 0; display: grid; place-items: center; text-align: center; padding: 24px; z-index: 1; background: radial-gradient(ellipse at 50% 120%,#304788,#1b264f 75%); }
  .tour-cover h3 { color: white; font-size: clamp(26px,3vw,40px); margin-bottom: 24px; }
  .tour-cover p { color: #d7dfef; font: 400 17px/1.6 'Nunito Sans',sans-serif; }
  .tour-cover .tour-cover-label { font: 600 14px/1.5 Poppins,sans-serif; text-transform: uppercase; letter-spacing: .12em; color: #b7c8ff; margin-bottom: 12px; }
  .tour-viewer-help { text-align: center; margin: 20px 0 0; color: #52617e; font: 400 16px/1.6 'Nunito Sans',sans-serif; }
  .tour-viewer-help a { display: inline-block; margin-left: 8px; }
  .tour-benefit-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; margin-top: 36px; }
  .tour-benefit-grid .photo-step-number { font-size: 20px; margin-bottom: 14px; }
  .tour-process { padding-bottom: 24px; }
  @media(max-width:991px) { .tour-intro { gap: 32px; } .tour-benefit-grid { gap: 24px; } }
  @media(max-width:767px) {
    .tour-hero-visual img { height: 370px; }
    .tour-intro, .tour-format-grid, .tour-benefit-grid { grid-template-columns: 1fr; gap: 24px; }
    .tour-format-grid, .tour-benefit-grid { margin-top: 28px; }
    .tour-viewer { aspect-ratio: auto; height: 430px; min-height: 0; }
    .tour-viewer-help a { margin: 8px 0 0; }
    .tour-benefit-grid article { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; }
    .tour-benefit-grid .photo-step-number { grid-row: span 2; }
    .tour-benefit-grid p { grid-column: 2; font-size: 16px; }
    .tour-benefit-grid h3 { font-size: 19px; margin-bottom: 8px; }
  }
`;
